import { render, staticRenderFns } from "./StorageOverageBanner.vue?vue&type=template&id=a9abc19e&scoped=true"
import script from "./StorageOverageBanner.vue?vue&type=script&lang=js"
export * from "./StorageOverageBanner.vue?vue&type=script&lang=js"
import style0 from "./StorageOverageBanner.vue?vue&type=style&index=0&id=a9abc19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9abc19e",
  null
  
)

export default component.exports